<template>
  <b-form
    ref="statsForm"
    novalidate
    :validated="validated">
    <b-form-group label="Default Game Type">
      <b-select
        v-model="stats.defaultGameType"
        required>
        <b-select-option
          v-for="(gameTypeVal, gameTypeName) in gameTypes"
          :key="gameTypeName"
          :value="gameTypeVal">
          {{ gameTypeName }}
        </b-select-option>
      </b-select>
    </b-form-group>
    <b-form-group label="Enabled Game Types">
      <b-checkbox-group
        v-model="enabledGameTypes"
        stacked>
        <b-checkbox
          v-for="(gameTypeVal, gameTypeName) in gameTypes"
          :key="gameTypeName"
          :value="gameTypeVal">
          {{ gameTypeName }}
        </b-checkbox>
      </b-checkbox-group>
    </b-form-group>
    <b-form-group
      label="Minimum Stats Year"
      :description="`Must be a valid year between 1800 and ${minimumSupportedSeasonMax}`">
      <b-input
        v-model="stats.minimumSupportedSeason"
        number
        type="number"
        min="1800"
        :max="minimumSupportedSeasonMax"
        required />
    </b-form-group>
  </b-form>
</template>

<script>

export default {
  name: "StatsForm",
  props: {
    value: {
      type: Object,
      default: () => ({
        "defaultGameType": 4,
        "enabledGameTypeMask": 254,
        "minimumSupportedSeason": 1871,
      }),
    },
  },
  data: () => ({
    validated: false,
    gameTypes: {
      "Exhibition": 1,
      "Spring Training": 2,
      "Regular Season": 4,
      "Postseason (Combined)": 8,
      "World Series": 16,
      "League Championship Series": 32,
      "Division Series": 64,
      "Wild Card": 128,
    },
    enabledGameTypes: [],
  }),
  computed: {
    stats: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit("input", value)
      },
    },
    minimumSupportedSeasonMax() {
      return new Date().getUTCFullYear()
    },
  },
  watch: {
    enabledGameTypes(newVal) {
      this.stats.enabledGameTypeMask = newVal.reduce((total, val) => total + val)
    },
  },
  created() {
    this.initEnabledGameState(this.stats.enabledGameTypeMask)
  },
  methods: {
    initEnabledGameState(gameTypeMask) {
      this.enabledGameTypes = Object.values(this.gameTypes)
        .filter(it => gameTypeMask & it) // Not a bug - for once, we actually want to perform a bitwise AND!
    },
    isValid() {
      this.validated = true
      return this.$refs.statsForm.checkValidity()
    },
  },
}
</script>

<style scoped>

</style>
